// import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import ArrowIcon from 'assets/leftArrow.svg';
import { tabValueAtom } from '_state/signature';
// import { useEffectAfterMount } from 'hooks';
// import { equalsCheck } from 'utils/helperFunctions';
// import {
//   detailsDefault,
//   detailsInitial,
//   meetingDetailsDefault,
//   meetingDetailsInitial,
// } from '_state/signatureDefaultValues';

const SignatureButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const details = useRecoilValue(detailsAtom);
  // const meetingDetails = useRecoilValue(meetingDetailsAtom);
  const tableValue = useRecoilValue(tabValueAtom);

  // const [firstMount, setFirstMount] = useState(false);

  // useEffectAfterMount(() => {
  //   if (!firstMount) setFirstMount(true);
  // }, [details, meetingDetails]);

  return ['/', '/email-signature', '/v-card'].includes(location.pathname) ? (
    <Button
      variant="contained"
      color="secondary"
      onClick={() => navigate('/verification')}
      sx={{
        textTransform: 'none',
        '&.MuiButtonBase-root:hover': {
          bgcolor: '#FF8140',
        },
      }}
      // disabled={
      //   (tableValue === 'Email Signature' &&
      //     (equalsCheck(details, detailsDefault) || equalsCheck(details, detailsInitial))) ||
      //   (tableValue === 'Meeting Signature' &&
      //     (equalsCheck(meetingDetails, meetingDetailsDefault) ||
      //       equalsCheck(meetingDetails, meetingDetailsInitial)))
      // }
    >
      Create {tableValue}
    </Button>
  ) : (
    <Button
      sx={{
        textTransform: 'none',
        '&.MuiButtonBase-root:hover': {
          bgcolor: '#F7F7F7',
        },
      }}
      variant="contained"
      onClick={() =>
        navigate(tableValue === 'Virtual Background' ? '/v-card' : '/', { replace: true })
      }
      startIcon={
        <Icon
          sx={{
            width: `24px`,
            height: `24px`,
            '& img': {
              display: 'block',
            },
          }}
        >
          <img alt="edit" src={ArrowIcon} />
        </Icon>
      }
      color="info"
    >
      Back to Generator
    </Button>
  );
};

export default SignatureButton;
